module.exports = __WEBPACK_EXTERNAL_MODULE__mfe_mfe_access_remoteEntry_mjs_8ceead07__;